import { render, staticRenderFns } from "./extension-program.vue?vue&type=template&id=1af93cb1&"
import script from "./extension-program.vue?vue&type=script&lang=js&"
export * from "./extension-program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports